// import { jsPDF } from "jspdf";
// import * as XLSX from "xlsx";
import axios from "axios"
import { adminApiHeader, getcurrentLocationApi, siteThemApi } from "../CommonApis/CommonApiUrl";
import { useMyContext } from "../../components/Provider/CommonProvider";
import { getItem } from "../../Utils/localStorageUtils";

const isHttpOrHttps = async (url) => {
    const regex = /^(http|https):\/\//;
    return regex.test(url);
};

const URLGenerater = (URLNAME) => {
    return URLNAME.replace(/ /g, '-').replace(/_/g, '-').toLowerCase();
}
const URLDashRemover = (URLNAME) => {
    return URLNAME.replace(/-/g, '  ');
}
const LogOut = (PATH) => {
    setTimeout(() => {
        localStorage.clear();
        window.location.href = PATH;
    }, 1000);
}
const capsFirstLetter = (str) => {
    return str?.charAt(0).toUpperCase() + str?.slice(1);
}

const currentIpAddressDetails = async () => {
    try {
        const responseIP = await axios.get(`${getcurrentLocationApi}`);
        return responseIP?.data;
    } catch (error) {
        console.error('Error fetching IP address details:', error);
        return null;
    }
};
const formatDate = (timestamp) => {
    const date = new Date(timestamp);

    const dateOptions = {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    };

    const timeOptions = {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true // AM/PM format
    };

    const formattedDate = date.toLocaleDateString('en-US', dateOptions);
    const formattedTime = date.toLocaleTimeString('en-US', timeOptions);

    return (
        <>
            <div>{formattedDate}</div>
            <div className='size13'>{formattedTime}</div>
        </ >
    );
}

const formatDateTimeText = (timestamp) => {
    if (!timestamp) return "-";

    const date = new Date(timestamp);
    if (Number.isNaN(date.getTime())) return timestamp;

    return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
    });
}

const findUploadName = (value) => {
    const findRole = {
        1: "Admin",
        4: "Partner",
    }
    return findRole?.[value]
}


const PDFGenerator = async (data, fileName) => {
    const { jsPDF } = await import("jspdf");
    await import("jspdf-autotable");
    const doc = new jsPDF();
    const PDFColumns = ["INDEX", "ID", "TITLE", "UPLOADED BY", "STATUS", "BANNER", "UPLOAD ON"];
    const database = data?.map((item, index) => [
        index + 1,
        item?.id,
        item?.title,
        item?.uploaded_by,
        item?.active,
        item?.banner,
        item?.id
    ]);
    doc.autoTable({
        startY: 10,
        startX: 10,
        head: [PDFColumns],
        body: database,
        margin: { top: 5, right: 5, bottom: 5, left: 5 },
        styles: {
            cellPadding: 3,
            fontSize: 10,
            lineColor: [240, 240, 240],
            lineWidth: 0.1,
        }
    });
    doc.save(`${fileName}.pdf`);
};

const XLSXGenerator = async (data, fileName) => {
    const XLSX = await import("xlsx");
    const extractedData = data.map((item, index) => {
        return {
            Index: index + 1,
            ID: item?.id,
            TITLE: item?.title,
            UPLOADED_BY: item?.uploaded_by,
            STATUS: item?.active,
            BANNER: item?.banner,
            UPLOAD_ON: item?.id
        };
    });
    var wb = XLSX.utils.book_new(), ws = XLSX.utils.json_to_sheet(extractedData);
    XLSX.utils.book_append_sheet(wb, ws, "MySheet");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
};

const CSVAdvertiseList = [
    { label: "ID", key: "id" },
    { label: "Ads Name", key: "ads_name" },
    { label: "Ads Position", key: "ads_position" },
    { label: "Ads Category", key: "ads_category_name" },
    { label: "Status", key: "status" },
    { label: "Upload On", key: "createdAt" },
];

const PDFAdvertiseList = async (data, fileName) => {
    const { jsPDF } = await import("jspdf");
    await import("jspdf-autotable");
    const doc = new jsPDF();
    const PDFColumns = ["ID", "Ads Name", "Ads Position", "Ads Category", "Status", "Upload On"];
    const database = data?.map((item, index) => [
        index + 1,
        item?.id,
        item?.ads_name,
        item?.ads_category_name,
        item?.status,
        item?.createdAt
    ]);
    doc.autoTable({
        startY: 10,
        startX: 10,
        head: [PDFColumns],
        body: database,
        margin: { top: 5, right: 5, bottom: 5, left: 5 },
        styles: {
            cellPadding: 3,
            fontSize: 10,
            lineColor: [240, 240, 240],
            lineWidth: 0.1,
        }
    });
    doc.save(`${fileName}.pdf`);
};
const XLSXAdvertiseListGenerator = async (data, fileName) => {
    const XLSX = await import("xlsx");
    const extractedData = data.map((item, index) => {
        return {
            Index: index + 1,
            ID: item?.id,
            Ads_Name: item?.ads_name,
            Ads_Position: item?.ads_position,
            Ads_Category: item?.ads_category_name,
            Status: item?.status,
            Upload_On: item?.createdAt

        };
    });
    var wb = XLSX.utils.book_new(), ws = XLSX.utils.json_to_sheet(extractedData);
    XLSX.utils.book_append_sheet(wb, ws, "MySheet");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
};


const CSVColumn = [
    { label: "ID", key: "id" },
    { label: "TITLE", key: "title" },
    { label: "UPLOADED BY", key: "uploaded_by" },
    { label: "STATUS", key: "active" },
    { label: "BANNER", key: "banner" },
    { label: "UPLOAD ON", key: "upload_on" },
]


const albumPDFGenerator = async (data, fileName) => {
    const { jsPDF } = await import("jspdf");
    await import("jspdf-autotable");
    const doc = new jsPDF();
    const PDFColumns = ["INDEX", "ID", "TITLE", "UPLOADED BY", "UPLOAD ON"];
    const database = data?.map((item, index) => [
        index + 1,
        item?.id,
        item?.albumname,
        item?.uploaded_by,
        item?.id
    ]);
    doc.autoTable({
        startY: 10,
        startX: 10,
        head: [PDFColumns],
        body: database,
        margin: { top: 5, right: 5, bottom: 5, left: 5 },
        styles: {
            cellPadding: 3,
            fontSize: 10,
            lineColor: [240, 240, 240],
            lineWidth: 0.1,
        }
    });
    doc.save(`${fileName}.pdf`);
};

const albumXLSXGenerator = async (data, fileName) => {
    const XLSX = await import("xlsx");
    const extractedData = data.map((item, index) => {
        return {
            Index: index + 1,
            ID: item?.id,
            TITLE: item?.albumname,
            UPLOADED_BY: item?.uploaded_by,
            UPLOAD_ON: item?.id
        };
    });
    var wb = XLSX.utils.book_new(), ws = XLSX.utils.json_to_sheet(extractedData);
    XLSX.utils.book_append_sheet(wb, ws, "MySheet");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
};

const albumCSVColumn = [
    { label: "ID", key: "id" },
    { label: "TITLE", key: "albumname" },
    { label: "UPLOADED BY", key: "uploaded_by" },
    { label: "UPLOAD ON", key: "upload_on" },
];

// artists 

const artistPDFGenerator = async (data, fileName) => {
    const { jsPDF } = await import("jspdf");
    await import("jspdf-autotable");
    const doc = new jsPDF();
    const PDFColumns = ["INDEX", "ID", "ARTISTS", "ARTISTS TYPE", "UPLOADED BY", "UPLOAD ON"];
    const database = data?.map((item, index) => [
        index + 1,
        item?.id,
        item?.artist_name,
        item?.artist_type,
        item?.uploaded_by,
        item?.id
    ]);
    doc.autoTable({
        startY: 10,
        startX: 10,
        head: [PDFColumns],
        body: database,
        margin: { top: 5, right: 5, bottom: 5, left: 5 },
        styles: {
            cellPadding: 3,
            fontSize: 10,
            lineColor: [240, 240, 240],
            lineWidth: 0.1,
        }
    });
    doc.save(`${fileName}.pdf`);
};

const artistXLSXGenerator = async (data, fileName) => {
    const XLSX = await import("xlsx");
    const extractedData = data.map((item, index) => {
        return {
            Index: index + 1,
            ID: item?.id,
            NAME: item?.artist_name,
            TYPE: item?.artist_type,
            UPLOADED_BY: item?.uploaded_by,
            UPLOAD_ON: item?.id
        };
    });
    var wb = XLSX.utils.book_new(), ws = XLSX.utils.json_to_sheet(extractedData);
    XLSX.utils.book_append_sheet(wb, ws, "MySheet");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
};

const artistCSVColumn = [
    { label: "ID", key: "id" },
    { label: "NAME", key: "artist_name" },
    { label: "ARTISTS TYPE", key: "artist_type" },
    { label: "UPLOADED BY", key: "uploaded_by" },
    { label: "UPLOAD ON", key: "upload_on" },
];

const defaultLightTheme = {
    body: '#fff',
    text: "#1d1f21",
    button: "#139DF2",
    buttonText: "#fff",
    secondarybody: '#f5f7fc',
}
const defaultDarkTheme = {
    body: '#1f222a',
    text: '#fdfcfc',
    button: '#4db8ff',
    buttonText: "#fff",
    secondarybody: '#2d3038',
};

const PDFGeneratorUser = async (data, fileName) => {
    const { jsPDF } = await import("jspdf");
    await import("jspdf-autotable");
    const doc = new jsPDF();
    const PDFColumns = ["USER ID", "USERNAME", "E-MAIL", "MOBILE", "ROLE", "COUNTRY", "STATE", "CITY", "DOB", "REGISTRED ON", "STATUS"];
    const database = data?.map((item, index) => [
        item?.id,
        item?.name,
        item?.email,
        item?.mobile,
        item?.role,
        item?.country,
        item?.state,
        item?.city,
        item?.DOB,
        item?.created_at,
        item?.active
    ]);
    doc.autoTable({
        startY: 10,
        startX: 10,
        head: [PDFColumns],
        body: database,
        margin: { top: 5, right: 5, bottom: 5, left: 5 },
        styles: {
            cellPadding: 3,
            fontSize: 10,
            lineColor: [240, 240, 240],
            lineWidth: 0.1,
        }
    });
    doc.save(`${fileName}.pdf`);
};

const XLSXGeneratorUser = async (data, fileName) => {
    const XLSX = await import("xlsx");
    const extractedData = data.map((item, index) => {
        return {
            Index: index + 1,
            ID: item?.id,
            USERNAME: item?.name,
            CONTACT: item?.mobile,
            EMAIL: item?.email,
            ROLE: item?.role,
            STATUS: item?.active,
            UPLOAD_ON: item?.created_at
        };
    });
    var wb = XLSX.utils.book_new(), ws = XLSX.utils.json_to_sheet(extractedData);
    XLSX.utils.book_append_sheet(wb, ws, "MySheet");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
};

const CSVColumnUser = [
    { label: "USER ID", key: "id" },
    { label: "USERNAME", key: "name" },
    { label: "E-MAIL", key: "email" },
    { label: "MOBILE", key: "mobile" },
    { label: "ROLE", key: "role" },
    { label: "COUNTRY", key: "country" },
    { label: "STATE", key: "state" },
    { label: "CITY", key: "city" },
    { label: "DOB", key: "DOB" },
    { label: "REGISTRED ON", key: "created_at" },
    { label: "STATUS", key: "active" },
];

const PDFGeneratorSubscriber = async (data, fileName) => {
    const { jsPDF } = await import("jspdf");
    await import("jspdf-autotable");
    const doc = new jsPDF({ orientation: 'landscape' });
    const PDFColumns = ["USER ID", "USERNAME", "TRANSCATION ID", "CURRENCY", "PRICE (DECIMAL)", "PRICE PAID", "INTERVAL", "START DATE", "END DATE", "PLAN", "DEVICE", "DEVICE COUNT", "IP ADDRESS", "COUNTRY", "REGION", "CITY", "SUBSCRIPTION ON", "TYPE", "PAYMENT TYPE",];
    const database = data?.map((item, index) => [
        item?.user_id || "-",
        item?.user_name || "-",
        item?.subscription_id || "-",
        item?.subscription_currency || "-",
        item?.subscription_price || "-",
        item?.subscription_price_paid || "-",
        item?.subscriptions_days || "-",
        formatDateTimeText(item?.subscription_starts_at),
        formatDateTimeText(item?.subscriptions_ends_at),
        item?.plans_name || "-",
        item?.device || "-",
        item?.device_count || "-",
        item?.ip_address || "-",
        item?.countryname || "-",
        item?.regionname || "-",
        item?.cityname || "-",
        formatDateTimeText(item?.createdAt),
        item?.PaymentGateway || "-",
        item?.Payment_type || "-",
    ]);
    doc.autoTable({
        startY: 20,
        head: [PDFColumns],
        body: database,
        margin: { top: 15, left: 10, right: 10 },
        tableWidth: 'auto',
        styles: {
            fontSize: 6.5,
            cellPadding: 1,
            overflow: 'linebreak',
            halign: 'center',
            valign: 'middle',
        },
        headStyles: {
            fontSize: 6,
            fontStyle: 'bold',
            halign: 'center',
            valign: 'middle',
            cellPadding: 1,
        },
        columnStyles: {
            default: { cellWidth: 'auto' },
        },
    });
    doc.save(`${fileName}.pdf`);
};

const XLSXGeneratorSubscriber = async (data, fileName) => {
    const XLSX = await import("xlsx");
    const extractedData = data.map((item, index) => {
        return {
            Index: index + 1,
            "User ID": item?.user_id || "-",
            "Username": item?.user_name || "-",
            "Transaction ID": item?.subscription_id || "-",
            "Currency": item?.subscription_currency || "-",
            "Price": item?.subscription_price || "-",
            "Price Paid": item?.subscription_price_paid || "-",
            "Interval (Days)": item?.subscriptions_days || "-",
            "Start Date": formatDateTimeText(item?.subscription_starts_at),
            "End Date": formatDateTimeText(item?.subscriptions_ends_at),
            "Plan Name": item?.plans_name || "-",
            "Device": item?.device || "-",
            "IP Address": item?.ip_address || "-",
            "Country": item?.countryname || "-",
            "Region": item?.regionname || "-",
            "City": item?.cityname || "-",
            "Subscription On": formatDateTimeText(item?.createdAt),
            "Payment Type": item?.Payment_type || "-",
            "Gateway": item?.PaymentGateway || "-"
        };
    });
    var wb = XLSX.utils.book_new(), ws = XLSX.utils.json_to_sheet(extractedData);
    XLSX.utils.book_append_sheet(wb, ws, "MySheet");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
};

const CSVColumnSubscriber = [
    { label: "USER ID", key: "user_id" },
    { label: "USERNAME", key: "user_name" },
    { label: "TRANSCATION ID", key: "subscription_id" },
    { label: "CURRENCY", key: "subscription_currency" },
    { label: "PRICE (DECIMAL)", key: "subscription_price" },
    { label: "PRICE PAID", key: "subscription_price_paid" },
    { label: "INTERVAL", key: "subscriptions_days" },
    { label: "START DATE", key: "subscription_starts_at" },
    { label: "END DATE", key: "subscriptions_ends_at" },
    { label: "PLAN", key: "plans_name" },
    { label: "DEVICE", key: "device" },
    { label: "DEVICE COUNT", key: "device_count" },
    { label: "IP ADDRESS", key: "ip_address" },
    { label: "COUNTRY", key: "countryname" },
    { label: "REGION", key: "regionname" },
    { label: "CITY", key: "cityname" },
    { label: "SUBSCRIPTION ON", key: "createdAt" },
    { label: "TYPE", key: "PaymentGateway" },
    { label: "PAYMENT TYPE", key: "Payment_type" },
];
const PDFGeneratorPPV = async (data, fileName) => {
    const { jsPDF } = await import("jspdf");
    await import("jspdf-autotable");
    const doc = new jsPDF('landscape'); // landscape gives more width

    const PDFColumns = [
        "S.NO", "USER ID", "SOURCE", "SOURCE ID", "TRANSACTION ID", "CURRENCY", "PRICE", "PRICE PAID",
        "TYPE", "DEVICE", "IP ADDRESS", "COUNTRY", "REGION", "CITY", "STATUS", "PURCHASED ON"
    ];

    const database = data?.map((item, index) => [
        index + 1,
        item?.user_id || "-",
        item?.source || "-",
        item?.source_id || "-",
        item?.payment_id || "-",
        item?.currency || "-",
        item?.payment_price || "-",
        item?.price_paid || "-",
        item?.PaymentGateway || "-",
        item?.device || "-",
        item?.ip_address || "-",
        item?.countryname || "-",
        item?.regionname || "-",
        item?.cityname || "-",
        item?.current_status || "-",
        item?.createdAt || "-"
    ]);

    doc.autoTable({
        startY: 15,
        head: [PDFColumns],
        body: database,
        margin: { top: 10, left: 10, right: 10 },
        styles: {
            fontSize: 8,
            cellPadding: 2,
            overflow: 'linebreak',
            halign: 'center',
            valign: 'middle',
        },
        headStyles: {
            fontSize: 7,
            fontStyle: 'bold',
            halign: 'center',
            valign: 'middle',
            cellPadding: 1.5,
        },
        columnStyles: {
            0: { cellWidth: 10 },
            4: { cellWidth: 35 },
            10: { cellWidth: 30 },
            default: { cellWidth: 'wrap' },
        },
    });
    doc.save(`${fileName}.pdf`);
};

const XLSXGeneratorPPV = async (data, fileName) => {
    const XLSX = await import("xlsx");
    const extractedData = data.map((item, index) => {
        return {
            Index: index + 1,
            ID: item?.id,
            USERNAME: item?.user_name,
            TRANSCATIONID: item?.payment_id,
            TYPE: item?.PaymentGateway,
            PRICE: item?.payment_price,
            COUNTRY: item?.countryname
        };
    });
    var wb = XLSX.utils.book_new(), ws = XLSX.utils.json_to_sheet(extractedData);
    XLSX.utils.book_append_sheet(wb, ws, "MySheet");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
};

const CSVColumnPPV = [
    { label: "ID", key: "id" },
    { label: "USER ID", key: "user_id" },
    { label: "SOURCE", key: "source" },
    { label: "SOURCE ID", key: "source_id" },
    { label: "TRANSCATION ID", key: "payment_id" },
    { label: "CURRENCY", key: "currency" },
    { label: "PRICE", key: "payment_price" },
    { label: "PRICE PAID", key: "price_paid" },
    { label: "TYPE", key: "PaymentGateway" },
    { label: "DEVICE", key: "device" },
    { label: "IP ADDRESS", key: "ip_address" },
    { label: "COUNTRY", key: "countryname" },
    { label: "REGION", key: "regionname" },
    { label: "CITY", key: "cityname" },
    { label: "STATUS", key: "current_status" },
    { label: "PURCHASED ON", key: "createdAt" }
];

const CSVColumnAppPlan = [
    { label: "ID", key: "id" },
    { label: "PLAN PRICE", key: "plan_price" },
    { label: "PRODUCT ID", key: "product_id" },
    { label: "UPLOAD-ON", key: "upload_on" },
];

const CSVColumnDevices = [
    { label: "ID", key: "id" },
    { label: "DEVICES", key: "devices_name" },
];

const CSVColumnPage = [
    { label: "ID", key: "id" },
    { label: "PAGES", key: "title" },
    { label: "URL", key: "slug" },
    { label: "STATUS", key: "active" },
    { label: "UPLOAD ON", key: "upload_on" },
];
const CSVColumnPlan = [
    { label: "ID", key: "id" },
    { label: "PLAN NAME", key: "plans_name" },
    { label: "UPLOAD ON", key: "upload_on" },
];


const PDFGeneratorAppPlan = async (data, fileName) => {
    const { jsPDF } = await import("jspdf");
    await import("jspdf-autotable");
    const doc = new jsPDF();
    const PDFColumns = ["INDEX", "ID", "PLAN PRICE", "PRODUCT ID", "UPLOAD-ON"];
    const database = data?.map((item, index) => [
        index + 1,
        item?.id,
        item?.plan_price,
        item?.product_id,
        item?.id,
    ]);
    doc.autoTable({
        startY: 10,
        startX: 10,
        head: [PDFColumns],
        body: database,
        margin: { top: 5, right: 5, bottom: 5, left: 5 },
        styles: {
            cellPadding: 3,
            fontSize: 10,
            lineColor: [240, 240, 240],
            lineWidth: 0.1,
        }
    });
    doc.save(`${fileName}.pdf`);
};

const XLSXGeneratorAppPlan = async (data, fileName) => {
    const XLSX = await import("xlsx");
    const extractedData = data.map((item, index) => {
        return {
            Index: index + 1,
            ID: item?.id,
            PLAN_PRICE: item?.plan_price,
            PRODUCT_ID: item?.product_id,
            UPLOAD_ON: item?.id,
        };
    });
    var wb = XLSX.utils.book_new(), ws = XLSX.utils.json_to_sheet(extractedData);
    XLSX.utils.book_append_sheet(wb, ws, "MySheet");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
};

const PDFGeneratorDevicePlan = async (data, fileName) => {
    const { jsPDF } = await import("jspdf");
    await import("jspdf-autotable");
    const doc = new jsPDF();
    const PDFColumns = ["INDEX", "ID", "DEVICES"];
    const database = data?.map((item, index) => [
        index + 1,
        item?.id,
        item?.devices_name,
    ]);
    doc.autoTable({
        startY: 10,
        startX: 10,
        head: [PDFColumns],
        body: database,
        margin: { top: 5, right: 5, bottom: 5, left: 5 },
        styles: {
            cellPadding: 3,
            fontSize: 10,
            lineColor: [240, 240, 240],
            lineWidth: 0.1,
        }
    });
    doc.save(`${fileName}.pdf`);
};

const XLSXGeneratorDevicePlan = async (data, fileName) => {
    const XLSX = await import("xlsx");
    const extractedData = data.map((item, index) => {
        return {
            Index: index + 1,
            ID: item?.id,
            Device_Name: item?.devices_name,
        };
    });
    var wb = XLSX.utils.book_new(), ws = XLSX.utils.json_to_sheet(extractedData);
    XLSX.utils.book_append_sheet(wb, ws, "MySheet");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
};

const PDFGeneratorPage = async (data, fileName) => {
    const { jsPDF } = await import("jspdf");
    await import("jspdf-autotable");
    const doc = new jsPDF();
    const PDFColumns = ["INDEX", "ID", "PAGES", "URL", "STATUS", "UPLOAD-ON"];
    const database = data?.map((item, index) => [
        index + 1,
        item?.id,
        item?.title,
        item?.slug,
        item?.active,
        item?.id,
    ]);
    doc.autoTable({
        startY: 10,
        startX: 10,
        head: [PDFColumns],
        body: database,
        margin: { top: 5, right: 5, bottom: 5, left: 5 },
        styles: {
            cellPadding: 3,
            fontSize: 10,
            lineColor: [240, 240, 240],
            lineWidth: 0.1,
        }
    });
    doc.save(`${fileName}.pdf`);
};

const XLSXGeneratorPage = async (data, fileName) => {
    const XLSX = await import("xlsx");
    const extractedData = data.map((item, index) => {
        return {
            Index: index + 1,
            ID: item?.id,
            Page: item?.title,
            URL: item?.slug,
            status: item?.active,
            upload_on: item?.id
        };
    });
    var wb = XLSX.utils.book_new(), ws = XLSX.utils.json_to_sheet(extractedData);
    XLSX.utils.book_append_sheet(wb, ws, "MySheet");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
};

const PDFGeneratorPlan = async (data, fileName) => {
    const { jsPDF } = await import("jspdf");
    await import("jspdf-autotable");
    const doc = new jsPDF();
    const PDFColumns = ["INDEX", "ID", "PLAN NAME", "PLAN DURATION", "PRICE", "UPLOAD ON"];
    const database = data?.map((item, index) => [
        index + 1,
        item?.id,
        item?.plans_name,
        item?.billing_interval,
        item?.price,
        item?.id,
    ]);
    doc.autoTable({
        startY: 10,
        startX: 10,
        head: [PDFColumns],
        body: database,
        margin: { top: 5, right: 5, bottom: 5, left: 5 },
        styles: {
            cellPadding: 3,
            fontSize: 10,
            lineColor: [240, 240, 240],
            lineWidth: 0.1,
        }
    });
    doc.save(`${fileName}.pdf`);
};
const XLSXGeneratorPlan = async (data, fileName) => {
    const XLSX = await import("xlsx");
    const extractedData = data.map((item, index) => {
        return {
            Index: index + 1,
            ID: item?.id,
            Plan_Name: item?.plans_name,
            Plan_Duration: item?.billing_interval,
            Plan_Price: item?.price,
            upload_on: item?.id
        };
    });
    var wb = XLSX.utils.book_new(), ws = XLSX.utils.json_to_sheet(extractedData);
    XLSX.utils.book_append_sheet(wb, ws, "MySheet");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
};


const donwloadCSV = (data, fileName) => {
    //console.log(data)
    const convertToCSV = (data) => {
        const header = Object.keys(data?.[0]).join(',');
        const rows = data.map(row => Object.values(row).join(',')).join('\n');
        return header + '\n' + rows;
    };
    const csvContent = convertToCSV(data);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `FILTERED-${fileName}.csv`;
    link.click();
}
const downloadPDF = async (data, fileName, columns) => {
    const { jsPDF } = await import("jspdf");
    await import("jspdf-autotable");
    const doc = new jsPDF();
    if (!Array.isArray(columns) || columns.length === 0) {
        console.error('Invalid columns array');
        return;
    }
    const PDFColumns = columns.map(col => col.toLowerCase().replace(/\s+/g, '_'));
    if (!Array.isArray(data) || data.length === 0) {
        console.error('Invalid data array');
        return;
    }
    const database = data?.map((row, index) => {
        const rowData = [index + 1];
        PDFColumns.slice(1).forEach((col) => {
            if (row.hasOwnProperty(col)) {
                rowData.push(row[col]);
            } else {
                rowData.push('');
            }
        });
        return rowData;
    });
    doc.autoTable({
        startY: 10,
        startX: 10,
        head: [columns],
        body: database,
        margin: { top: 5, right: 5, bottom: 5, left: 5 },
        styles: {
            cellPadding: 3,
            fontSize: 10,
            lineColor: [240, 240, 240],
            lineWidth: 0.1,
        },
    });
    doc.save(`${fileName}.pdf`);
};
const videodownloadPDF = async (data, fileName, columns) => {
    const { jsPDF } = await import("jspdf");
    await import("jspdf-autotable");
    const doc = new jsPDF();

    if (!Array.isArray(columns) || columns.length === 0) {
        console.error('Invalid columns array');
        return;
    }

    if (!Array.isArray(data) || data.length === 0) {
        console.error('Invalid data array');
        return;
    }

    const body = data.map((row) => columns.map(col => row[col] ?? ''));

    doc.autoTable({
        head: [columns],
        body,
        startY: 10,
        margin: { top: 10, left: 10, right: 10 },
        styles: {
            fontSize: 9,
            textColor: [40, 40, 40],
            lineColor: [200, 200, 200],
            lineWidth: 0.2,
            cellPadding: 4,
        },
        headStyles: {
            fillColor: [41, 128, 185], // Blue background
            textColor: 255,
            fontStyle: 'bold',
        },
        alternateRowStyles: {
            fillColor: [245, 245, 245], // Light grey for alternate rows
        },
        columnStyles: {
            0: { halign: 'center' }, // Center-align first column (S.NO)
        },
    });

    doc.save(`${fileName}.pdf`);
};
const downloadXLSX = async (data, fileName, columns) => {
    const XLSX = await import("xlsx");
    const XLSXolumns = columns.map(col => col.toLowerCase().replace(/\s+/g, '_'));

    const header = XLSXolumns.slice(1);
    const extractedData = data?.map((row, index) => {
        const rowData = { Index: index + 1 };

        header.forEach((col) => {
            if (row.hasOwnProperty(col)) {
                rowData[col] = row[col];
            } else {
                rowData[col] = '';
            }
        });
        return rowData;
    });
    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.json_to_sheet(extractedData, { header: ["Index", ...header] });
    XLSX.utils.book_append_sheet(wb, ws, "MySheet");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
};
const videodownloadXLSX = async (data, fileName, columns) => {
    const XLSX = await import("xlsx");
    const extractedData = data?.map((row, index) => {
        const rowData = { "S.NO": index + 1 };
        columns.slice(1).forEach((col) => {
            rowData[col] = row[col] ?? '';
        });
        return rowData;
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(extractedData, { header: columns });
    XLSX.utils.book_append_sheet(wb, ws, "MySheet");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
};


const slugGenerator = (name) => {
    return name?.trim().toLowerCase()
        .replace(/[<>→!@#$%^&*()_+=[\]{};'"\\|,.<>?/:\s]/g, " ")
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
}
export { isHttpOrHttps, slugGenerator, downloadXLSX, downloadPDF, donwloadCSV, XLSXGeneratorPlan, PDFGeneratorPlan, CSVColumnPlan, CSVColumnPage, PDFGeneratorPage, XLSXGeneratorPage, XLSXGeneratorDevicePlan, PDFGeneratorDevicePlan, CSVColumnDevices, findUploadName, formatDate, formatDateTimeText, PDFGeneratorPPV, XLSXGeneratorPPV, CSVColumnPPV, PDFGeneratorSubscriber, XLSXGeneratorSubscriber, CSVColumnSubscriber, PDFGeneratorUser, XLSXGeneratorUser, CSVColumnUser, URLGenerater, URLDashRemover, LogOut, capsFirstLetter, PDFGenerator, XLSXGenerator, CSVColumn, albumCSVColumn, albumPDFGenerator, albumXLSXGenerator, artistPDFGenerator, artistXLSXGenerator, artistCSVColumn, defaultLightTheme, defaultDarkTheme, CSVColumnAppPlan, CSVAdvertiseList, PDFGeneratorAppPlan, XLSXGeneratorAppPlan, currentIpAddressDetails, PDFAdvertiseList, XLSXAdvertiseListGenerator, videodownloadXLSX, videodownloadPDF }
